export default __webpack_public_path__ + "static/media/redux.4516fe25.jpg";